import { FormErrorMessage } from "@ecco/ui/form-error";
import type { BoxProps } from "@ecco/ui/box";
import { Box } from "@ecco/ui/box";
import type { PropsWithChildren } from "react";

export type DeliveryMethodWrapperProps = BoxProps &
    PropsWithChildren<{
        error: { value: string } | undefined;
    }>;

export const DeliveryMethodWrapper = ({
    children,
    error,
    ...props
}: DeliveryMethodWrapperProps) => {
    return (
        <Box
            tabIndex={0}
            border="1"
            cursor={"pointer"}
            py={{ base: 3, sm: 4 }}
            px={{ base: 2, sm: 4 }}
            borderColor="gray.50"
            w="full"
            _hover={{
                bg: "gray.100",
            }}
            _focusVisible={{
                outline: "none",
                boxShadow: "0 0 0 1.7px black",
            }}
            {...props}
        >
            {children}
            {error && <FormErrorMessage ml={8}>{error.value}</FormErrorMessage>}
        </Box>
    );
};
